<template lang="pug">
  .navbar
      el-menu.el-menu-side-nav-wrapper(
        :router="false"
        :default-active="activeLink"
        :collapse-transition="false"
        mode="vertical"
        v-if="computeSideBar"
        ref="sidebar"
      )
        .nav_wrapper
          img.logo-wrapper(src="@src/assets/navbar/logo1.png")
          img.logo-words-wrapper(src="@src/assets/navbar/logow.png")
          .items_wrapper(v-if="!isMobile")
            NavOverviewItem
            NavDetailsItem
            NavNotificationsItem
          .aaa(v-if="isMobile")
            el-dropdown(@command="navigateTo" trigger="click")
              span.nav-dropdown-trigger
                span {{ $t('sidebar.management') }}
              el-dropdown-menu(slot="dropdown")
                el-dropdown-item(command="/overview")
                  img(src="@src/assets/navbar/overview-map-dropdown.svg" style="width: 16px; margin-right: 8px; color: red;")
                  span {{ $t('navbar.overview') }}
                el-dropdown-item(command="/details")
                  img(src="@src/assets/navbar/details-list-dropdown.svg" style="width: 16px; margin-right: 8px;")
                  span {{ $t('navbar.details') }}
                el-dropdown-item(command="/notifications")
                  img(src="@src/assets/navbar/notifications-dropdown.svg" style="width: 16px; margin-right: 8px;")
                  span {{ $t('navbar.notifications') }}
                el-dropdown-item(command="/settings")
                  img(src="@src/assets/navbar/settings-dropdown.svg" style="width: 16px; margin-right: 8px;")
                  span {{ $t('navbar.settings') }}
          .field-filter(style="margin-top: 15px")
            FilterFieldDropdown(v-model="selectedFieldId")
          .profile_wrapper
            NavSettingsItem(v-if="!isMobile")
            .logout.text-underline.cursor-pointer(@click="handleLogout") {{ $t('auth.logout') }}
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { dynamicViewsConstants } from "@src/constants";
import { general } from "@src/services/dynamicViews/general";

import NavOverviewItem from "@components/horizontalNavBar/NavOverviewItem";
import NavDetailsItem from "@components/horizontalNavBar/NavDetailsItem";
import NavNotificationsItem from "@components/horizontalNavBar/NavNotificationsItem";

import NavSettingsItem from "@components/horizontalNavBar/NavSettingsItem";

import FilterFieldDropdown from "@components/_shared/FilterFieldDropdown";

export default {
  mixins: [general],

  components: {
    NavOverviewItem,
    NavDetailsItem,
    NavNotificationsItem,
    NavSettingsItem,
    FilterFieldDropdown,

  },

  data() {
    return {
      selectedFieldId: "",
      isMenuOpen: true,
      activeLink: this.$route.path,
      dynamicViewsConstants,
      isMobile: false,
      showDropdown: false,
      selectedRoute: ''
    };
  },

  computed: {
    ...mapState("auth", ["user"]),

    computeSideBar() {
      return (
        this.user &&
        this.activeLink !== "/set-password" &&
        this.activeLink !== "/change_email"
      );
    },
  },

  watch: {
    $route(newVal) {
      this.activeLink = newVal.path;
    },

    async selectedFieldId(){
      await this.handleSelectedField();
    }
  },

  mounted() {
    this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
  },

  methods: {
    ...mapMutations("field", ["setSelectedField", "setSelectedFieldInfoSettings"]),
    ...mapActions({
      logout: "auth/logout",
    }),
    ...mapActions("field", ["getSelectedField"]),

    checkMobile() {
      this.isMobile = window.innerWidth <= 1400;
    },

    navigateTo(path) {
      this.$router.push(path);
    },

    handleLogout() {
      this.logout().then(() => {
        this.$router.push({ name: "login" });
      });
    },

    async handleSelectedField(){
      if (this.selectedFieldId) {
        const response = await this.getSelectedField(this.selectedFieldId);
        this.setSelectedField(response)
        if(response.field_info_settings)
        this.setSelectedFieldInfoSettings(response.field_info_settings)
      }
      else {
        this.setSelectedField('all')
      }

    }
  }
};
</script>

